<template>
  <div id="app" class="vld-parent">
    <Header />
    <NavBar />
    <loading :active.sync="isLoading" 
    is-full-page></loading>
    {{ csrf }}
    <b-container id="content-container">
      <router-view></router-view>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'
import Cookies from 'js-cookie'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';

export default {
  name: 'app',
  components: {
    Header,
    NavBar,
    Footer,
    Loading
  },
  data: function () {
    var csrftoken = Cookies.get('csrftoken');
    return {
      csrf: csrftoken,
      isLoading: false
    }
  },
  computed: {
    username () {
      return this.$route.params.username
    }
  },
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  },
  beforeMount: function () {
    this.isLoading = true
    let that = this

    axios
    .get('http://127.0.0.1:8000/api/user/')
    .then(function (response) {
      console.log(response)
    })
    .finally(function () {
      that.isLoading = false
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

#content-container {
  padding: 1rem 0;
}

</style>
